module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "id": "m-t-mask",
      "transition": "modal"
    }
  }, [_c('div', {
    attrs: {
      "id": "m-t-wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "m-t-container"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n            Your session is about to expire due to inactivity.\n            "), _c('br'), _c('br'), _vm._v("\n            You will be automatically logged out in "), _c('span', {
    attrs: {
      "id": "timeout-seconds"
    }
  }, [_vm._v(_vm._s(_vm.time / 1000))]), _vm._v(" seconds.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.stayLoggedIn()
      }
    }
  }, [_vm._v("Stay Logged In")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Logout")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Session Expire Warning")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-745a5ff3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimeoutModal.vue
// module id = 962
// module chunks = 1